module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"since":"De:","until":"Até:"},"en-US":{"since":"Since:","until":"Until:"}}')
  delete Component.options._Ctor
}
